import headerLogo from '../../assets/img/aviator-header-logo.svg';
import '../../styles/game/Header.css'
import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, useContext } from 'react';
import { MenuButtons } from '../../providers/MenuButtonsContext.jsx';
import { useAuth } from "../../providers/AuthProvider";


function Header({ howToPlayOpen, GameRulesOpen, GameLimitsOpen, ProvablyFairOpen, FreeBetsOpen, BetsHistoryOpen, AvatarChangeModalOpen, isAvatar, setIsAvatar, isAviatorId, 
    setIsAviatorId, isUserBalance, setChatBar, chatBar, setIsNotifyOpen}) {
    // user interface info
    const { user } = useAuth()
    const [userData, setUserData] = useState(null);
    const [userBalance, setUserBalance] = useState(null);
    const { isSoundOn, setIsSoundOn, isMusicOn, setIsMusicOn, isAnimationOn, setIsAnimationOn } = useContext(MenuButtons)
    const [chatBarOpen, setChatBarOpen] = useState(false)
    
    const audioRef = useRef(null);

    async function getUserData() {
        const result = localStorage.getItem("user");
        const userDataInfo = await JSON.parse(result)
        setUserData(userDataInfo.userData)
    }

    useEffect(() => {
        if(user) {
            console.log(user)
            
        }

    }, [user])


    useEffect(() => {
        const token = localStorage.getItem("token");
        
        
        const fetchUserBalance = async () => {
            try {
                
                const response = await fetch(`${import.meta.env.VITE_API_URL}/api/user-balance`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`, // Передаем токен в заголовке
                    },
                  });
                
                if (response.ok) {
                  const data = await response.json()
                  setUserBalance(data.userBalance.usdBalance)

                } 
              } catch (err) {
                
                console.error("Ошибка:", err);
              }
        }
        
        fetchUserBalance()
        getUserData()
    }, [])

    //
    
    

    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const [isOpenMenu, setIsOpenMenu] = useState(false)
    const menuRef = useRef(null);
    const dropdownToggle = useRef(null);
    // const [isSoundOn, setIsSoundOn] = useState(true)
    // const [isMusicOn, setIsMusicOn] = useState(true)
    // const [isAnimationOn, setIsAnimationOn] = useState(true)

    // const [isSoundOn, setIsSoundOn] = useState(() => {
    //     const savedValue = localStorage.getItem("isSoundOn");
    //     return savedValue ? JSON.parse(savedValue) : true; // Парсим из строки или задаем значение по умолчанию
    // });

    // const [isMusicOn, setIsMusicOn] = useState(() => {
    //     const savedValue = localStorage.getItem("isMusicOn");
    //     return savedValue ? JSON.parse(savedValue) : true;
    // })

    // const [isAnimationOn, setIsAnimationOn] = useState(() => {
    //     const savedValue = localStorage.getItem("isAnimationOn");
    //     return savedValue ? JSON.parse(savedValue) : true;
    // })

    useEffect(() => {
        localStorage.setItem("isSoundOn", JSON.stringify(isSoundOn));
    }, [isSoundOn]);

    useEffect(() => {
        localStorage.setItem("isAnimationOn", JSON.stringify(isAnimationOn));
    }, [isAnimationOn]);

    useEffect(() => {
        localStorage.setItem("isMusicOn", JSON.stringify(isMusicOn));
    }, [isMusicOn]);
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target !== menuRef.current && event.target !== dropdownToggle.current && !menuRef.current.contains(event.target)) {
                setIsOpenMenu(false);
            }


        };

            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);


    }, []);

    const closeUserMenu = (callback) => {
        callback()
        setIsOpenMenu(false);
    }
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsOpenMenu(false)
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);



    const headerLogoImg = {
        height: "auto",
        width: "100%",
    }
    const wrap = {
        height: "100%",
        display: "flex",
        alignItems: "center",
    }
    const userPanel = {
        height: "100%",
        display: "flex",
        alignItems: "center"
    }


    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(number);
      };

      useEffect(() => {
        const handlePlayAudio = () => {
          const audio = audioRef.current;
          if (isMusicOn) {
            audio.volume = 0.4; // Установить громкость на 40%
            audio.play().catch((error) => {
              console.error("Ошибка воспроизведения аудио:", error);
            });
          }
    
          // Удаляем обработчик после первого клика
          document.body.removeEventListener("click", handlePlayAudio);
        };
    
        // Добавляем обработчик на body только при включённой музыке
        if (isMusicOn) {
          document.body.addEventListener("click", handlePlayAudio);
        }
    
        // Если музыка отключена, останавливаем воспроизведение
        if (!isMusicOn) {
          const audio = audioRef.current;
          audio.pause();
        }
    
        return () => {
          // Убираем обработчик при изменении isMusicOn или размонтировании компонента
          document.body.removeEventListener("click", handlePlayAudio);
        };
      }, [isMusicOn]);

    return (
        <div className={"header-wrapper provider"}>
            <div style={wrap}>
                <div className={"header-logo-wrapper"}>
                    <img style={headerLogoImg} src={headerLogo}/>
                </div>
                {/* <button className={"header-question"} onClick={howToPlayOpen}>
                    <div className={"question-img"}></div>
                    <span className={"how-to-play-text"}>{t("howToPlayComponent.howToPlay")}</span>
                </button> */}
                {/* <button onClick={() => changeLanguage("en")}>English</button>
                <button onClick={() => changeLanguage("ru")}>Русский</button>
                <button onClick={() => changeLanguage("uz")}>O'zbekcha</button> */}
                <audio ref={audioRef} loop style={{ display: "none" }}>
                    <source src="/assets/audio/bg_music.mp3" type="audio/mpeg" />

                </audio>
            </div>
            <div style={userPanel}>
                {user && <div className={"userBalanceWrap"}><span className={"userBalance"}>{isUserBalance ? formatNumber(isUserBalance) : ""}</span><span
                    className={"balanceCurrency"}>{user.mainWallet.toUpperCase()}</span></div>}
                <div className={"userWrapper"}>
                    <div className={"dropdownToggle burger-icon"} onClick={() => {
                            if (isOpenMenu) {
                                setIsOpenMenu(false);
                            } else {
                                setIsOpenMenu(true);
                            }
                    }} ref={dropdownToggle}>
                        {/*<div className={"burger-icon"}></div>*/}
                    </div>
                    <div className={`user-menu-dropdown ${isOpenMenu ? "show" : ""}`} ref={menuRef}>
                        <div className={'userMenuContainer'}>
                            <div className={'userMenuTitle'}>
                                <div className={'userInfo'}>
                                    <div className={'userAvatar'}>
                                        <img src={isAvatar ? isAvatar : ""} alt=""/>
                                    </div>
                                    <div className={'userIDNumber'}>{isAviatorId ? isAviatorId : ""}</div>
                                </div>
                                <div className={'avatar-change'} onClick={() => closeUserMenu(AvatarChangeModalOpen)}>
                                    <div className={'avatarChangeLogo'}></div>
                                    <div className={'avatarChangeText'}>
                                        <div>{t("change")}</div>
                                        <div>{t("avatar")}</div>
                                    </div>
                                </div>
                            </div>
                            <div className={'userMenuBody'}>
                                <div className={'userMenuList pb-20'}>
                                    <div className={'userMenuList-item'}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'sound-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("sound")}</span>
                                        </div>
                                        <div className={'um-switch'}>
                                            <div className={`um-input-switch ${isSoundOn ? "" : "off"}`} onClick={() => {
                                                setIsSoundOn(prev => !prev);
                                            }}>
                                                <span className={'switch-oval'}></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item'}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'music-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("music")}</span>
                                        </div>
                                        <div className={'um-switch'}>
                                            <div className={`um-input-switch ${isMusicOn ? "" : "off"}`} onClick={() => {
                                                setIsMusicOn(prev => !prev);
                                            }}>
                                                <span className={'switch-oval'}></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item'}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'animation-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("animation")}</span>
                                        </div>
                                        <div className={'um-switch'}>
                                            <div className={`um-input-switch ${isAnimationOn ? "" : "off"}`} onClick={() => {
                                                setIsAnimationOn(prev => !prev);
                                            }}>
                                                <span className={'switch-oval'}></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={'userMenuList'}>
                                    <div className={'userMenuList-item cursor-pointer'} onClick={() => closeUserMenu(FreeBetsOpen)}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'um-star-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("freeBets")}</span>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item cursor-pointer'} onClick={() => closeUserMenu(BetsHistoryOpen)}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'um-history-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("myBetHistory")}</span>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item cursor-pointer'} onClick={() => closeUserMenu(GameLimitsOpen)}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'um-limits-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("gameLimits")}</span>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item cursor-pointer'} onClick={() => closeUserMenu(howToPlayOpen)}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'um-help-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("howToPlay")}</span>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item cursor-pointer'} onClick={() => closeUserMenu(GameRulesOpen)}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'um-rules-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("gameRules")}</span>
                                        </div>
                                    </div>
                                    <div className={'userMenuList-item cursor-pointer'} onClick={() => closeUserMenu(ProvablyFairOpen)}>
                                        <div className={'um-list-item-title'}>
                                            <div className={'um-icon-wrapper'}>
                                                <div className={'um-provably-fair-icon'}></div>
                                            </div>
                                            <span className={'um-title-text'}>{t("provablyFairSettings")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!chatBar && <div className={"chatWrapper"}>
                    <div className={"chatBar"} onClick={() => setIsNotifyOpen(true)}>
                        <div className={"chat-icon"}></div>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default Header;